import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
	Box,
	Button,
	Card,
	Dialog,
	DialogActions,
	DialogTitle,
	IconButton,
	InputAdornment,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	TextField,
} from '@material-ui/core';
import ArrowRightIcon from '../../icons/ArrowRight';
import PencilAltIcon from '../../icons/PencilAlt';
import SearchIcon from '../../icons/Search';
import Scrollbar from '../Scrollbar';
import { PaginationResult } from '../../types/paginationResult';
import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import { Airfield } from '../../models/Airfield';
import { composeNotistackMessage } from '../../utils/common';
import TableRowsLoader from '../TableRowsLoader';
import { DeleteOutline } from '@material-ui/icons';
import { AirfieldService } from '../../services/AirfieldService';
import verifiedShield from '../../images/verified_Shield.png';


interface AirfieldsPublicListProps {
	airfields: PaginationResult<Airfield>;
	recordLimit: number;
	isLoading: boolean
}


const AirfieldsListTable: FC<AirfieldsPublicListProps> = (props) => {
	const { t } = useTranslation();
	const { airfields, recordLimit, isLoading } = props;



	return (
		<Card>
			<Box
				sx={{
					alignItems: 'center',
					display: 'flex',
					flexWrap: 'wrap',
					m: -1,
					p: 2
				}}
			>
				<Box
					sx={{
						m: 1,
						maxWidth: '100%',
						width: 500
					}}
				>

				</Box>
			</Box>
			<Scrollbar>
				<Box sx={{ minWidth: 700 }}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>
									{t('NAME')}
								</TableCell>
								<TableCell>
									{t('ICAO_CODE')}
								</TableCell>
								<TableCell>
									{t('REGION')}
								</TableCell>
								<TableCell>
									{t('PROVINCE')}
								</TableCell>
								<TableCell>
									{t('MUNICIPALITY')}
								</TableCell>
								<TableCell align="right">
									{t('ACTIONS')}
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{
								isLoading ?
									(<TableRowsLoader rowsNum={recordLimit} colsNum={6} />) :
									(
										<>
											{airfields?.items.map((airfield) => (
												<TableRow hover key={airfield.id}>
													<TableCell>
														<Box
															sx={{
																alignItems: 'center',
																display: 'flex'
															}}
														>
															<Box sx={{ ml: 1 }}>
																{airfield.name}
															</Box>
														</Box>
													</TableCell>
													<TableCell>
														{airfield.icaoCode}
													</TableCell>
													<TableCell>
														{airfield.region}
													</TableCell>
													<TableCell>
														{airfield.province}
													</TableCell>
													<TableCell>
														{airfield.municipality}
													</TableCell>
													<TableCell align="right">
														<Box sx={{
															display: 'flex',
															justifyContent: 'flex-end',
														}}>
															{airfield.isRegistred &&
																<Box sx={{ mt: 1 }}
																	component="img"
																	src={verifiedShield}
																	height={20}
																/>
															}

															<Tooltip title={t('DETAILS') || ''} aria-label={t('DETAILS') || ''}>
																<IconButton
																	component={RouterLink}
																	to={`details?airfieldId=${airfield.id}`}
																>
																	<SearchIcon fontSize="small" />
																</IconButton>
															</Tooltip>

														</Box>
													</TableCell>
												</TableRow>
											))}
										</>
									)
							}
						</TableBody>
					</Table>
				</Box>
			</Scrollbar>
		</Card>
	);
};

export default AirfieldsListTable;
